export default {
  eyebrow: 'Kumppaniportaali',
  title: 'Laskutus',
  description: 'Maksutapasi kuukausittaista alustalaskua varten sekä jokainen lasku täydellisine erittelyineen.',
  toasts: {
    checkout_error: 'Kassalle siirtyminen epäonnistui — yritä uudelleen.',
    action_error: 'Toiminto epäonnistui — yritä uudelleen.',
    onboarding_error: 'Vahvistusta ei voitu käynnistää — yritä uudelleen.',
    payment_method_in_use:
      'Ravintolalisenssisi laskutetaan tällä maksutavalla, joten sitä ei voi poistaa. Korvaa se uudella sen sijaan.',
  },
  payout_bank_account: {
    title: 'Tilipankkitili',
    description: 'Tulonjaon maksut saapuvat valuutassa {{currency}}. Stripe muuntaa siirron sen saapuessa.',
    toasts: {
      saved: 'Pankkitili tallennettu',
      save_failed: 'Pankkitiliä ei voitu tallentaa. Tarkista tiedot.',
    },
  },
  payout_onboarding: {
    title: 'Määritä maksutilisi',
    description:
      'Tulonjakosi maksetaan kuukausittain Stripe-maksutilille. Suorita vahvistus kerran — maksut ovat pidossa, kunnes se on tehty.',
    missing: {
      title: 'Vielä tarvitaan ennen kuin maksut voivat alkaa:',
      bank_account: 'Lisää pankkitili, jolle tulonjakosi tulee maksaa.',
      business_details: 'Täydennä yrityksesi tiedot, kuten osoite, verotunnus tai rekisterinumero.',
      people: 'Lisää yrityksesi edustajan, omistajien tai johtajien tiedot.',
      documents: 'Lataa Stripen pyytämät vahvistusasiakirjat.',
      terms: 'Hyväksy Stripen käyttöehdot.',
      other: 'Täytä Stripen pyytämät puuttuvat tiedot.',
    },
    start: 'Aloita vahvistus',
    continue: 'Jatka vahvistusta',
    ready: 'Maksutili vahvistettu — tulo-osuutesi maksetaan automaattisesti jokaisen laskutusjakson jälkeen.',
  },
  payment_method: {
    title: 'Maksutapa',
    empty: 'Ei tallennettua maksutapaa — kuukausilaskua ei voida vielä periä automaattisesti.',
    add: 'Lisää maksutapa',
    replace: 'Vaihda',
    remove: 'Poista',
    remove_confirm: {
      title: 'Poistetaanko tämä maksutapa?',
      description:
        'Kortti/valtuutus irrotetaan Stripestä heti. Ilman maksutapaa laskut — mukaan lukien jo lähetetyt — peritään automaattisen sijaan Stripen isännöimän laskun kautta.',
      confirm: 'Poista',
    },
  },
  invoices: {
    title: 'Laskut',
  },
};
